/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Injectable } from '@angular/core';
import { Constants } from 'app/core/models/constants';

@Injectable({providedIn: 'root'})
export class UiStateService {

  public get(name: string): string {
    return localStorage.getItem(name);
  }

  public delete(key: string): void {
    localStorage.removeItem(key);
  }


  constructor() {
  }


  private getUiState(): any[] {

    const v = localStorage.getItem(Constants.Cookies.KeyUiState);

    if (!v) {
      return [];
    }

    return JSON.parse(v);
  }

  public getUiStateForKey(key: string): any {

    const stateCookie = localStorage.getItem(Constants.Cookies.KeyUiState);

    if (!stateCookie) {
      return null;
    }

    const array = JSON.parse(stateCookie);

    const foundObject = array.find(f => f.key === key);
    return foundObject == null ? null : foundObject.value;
  }

  public setUiState(key: string, state: any): void {

    let stateKvPairs = this.getUiState();

    let i = stateKvPairs.findIndex(x => x.key === key);
    if (i < 0) {
      stateKvPairs.push({key: key, value: state});
    } else {
      stateKvPairs[i].value = state;
    }
    
    localStorage.setItem(Constants.Cookies.KeyUiState, JSON.stringify(stateKvPairs));        
  }

}
